import { Grid } from "@material-ui/core";
// import Title from "../common/title";
import ConferenceRoom from "./components/conferenceRoom";
import ServicesIntro from "./components/servicesIntro";

const Services = () => {
  return (
    <Grid container justify="center">
      <Grid item xs={12}>
        {/*<Title img={foodSpread} h3="Our" h1="Services" />*/}
      </Grid>

      <Grid item xs={11}>
        <ServicesIntro />
      </Grid>

      <Grid item xs={11}>
        <ConferenceRoom />
      </Grid>


    </Grid>
  );
};

export default Services;
